// Product ID → selected variant ID map (filled while rendering cards)
let tangent_selected_product_map;
let tangent_recommended_products;

const no_products_found_text = "No products found. Please retry!";

let tangent_client_domain_currency;
// Products currently selected for checkout / add-all-to-cart
let auto_add_to_bag_products = [];

// --- Icons used in step / time / CTA UI ---
const halfMoon = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#000000"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
</svg>
`;

const sunIcon = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#000000"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <circle cx="12" cy="12" r="4" />
  <path d="M12 2v2" />
  <path d="M12 20v2" />
  <path d="M5 5l1.5 1.5" />
  <path d="M17.5 17.5L19 19" />
  <path d="M2 12h2" />
  <path d="M20 12h2" />
  <path d="M5 19l1.5-1.5" />
  <path d="M17.5 6.5L19 5" />
</svg>
`;

const starIcon = `<img src="https://cdn.shopify.com/s/files/1/0838/0117/8412/files/Vector_06df4a2e-749d-47da-a9ae-47d4711cc2e3.svg?v=1784526351" width="16" height="16" />`

const plusIcon = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#ffffff"
  stroke-width="3"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 5v14" />
  <path d="M5 12h14" />
</svg>
`;

const tickIcon = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#000000"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M5 12l5 5L20 7" />
</svg>
`;

// --- Cached DOM nodes ---
const tangentProductSectionsWrapper = document.querySelector("#tangent_sections_wrapper");
const pregnancyMessageContainer = document.querySelector(".pregnancy-message-container");
const emailResultBlock = document.querySelector(".tangent-checkout-email-section");

const checkoutFinalPrice = document.querySelector(".tangent-checkout-final-price");
const checkoutSavingBadge = document.querySelector(".tangent-checkout-saving-badge");
const checkoutButton = document.querySelector(".tangent-checkout-button");
const checkoutOriginalPrice = document.querySelector(".tangent-checkout-original-price");
const checkoutEmailCount = document.querySelector(".tangent-checkout-email-count");
const checkouHeaderCount = document.querySelector(".tangent-checkout-header-count");
const mainProductCount = document.querySelector(".tangent-main-product-count");

let tangent_product_sections;
let tangent_text_sections;
let tangent_tags;
let sensitiveSkin = false;

// Fixed render order for routine steps
const sectionsList = [
    "section_oil_cleanse",
    "section_water_cleanse",
    "section_toner",
    "section_treatment",
    "section_treatment_senstive",
    "section_am_eyecare",
    "section_pm_eyecare",
    "section_am_nourish",
    "section_pm_nourish",
    "section_protect",
    "section_booster"
];

// Step title, AM/PM label, and header color per section
const sectionConfig = {
    section_oil_cleanse: {
        stepTitle: ["Étape 1 • Nettoyage à l'huile"],
        title: [`${sunIcon} AM/PM ${halfMoon}`],
        bgColor: ["#D5E7D2"]
    },
    section_water_cleanse: {
        stepTitle: ["Étape 2 •  Nettoyage à l'eau"],
        title: [`${sunIcon} AM / PM ${halfMoon}`],
        bgColor: ["#D5E7D2"]
    },
    section_toner: {
        stepTitle: ["Étape 3 • Toner"],
        title: [`${sunIcon} AM / PM ${halfMoon}`],
        bgColor: ["#D5E7D2"]
    },
    section_treatment: {
        stepTitle: ["Étape 4 • Soin du matin", "Étape 4 • Soin du soir"],
        title: [`${sunIcon} AM`, `PM ${halfMoon}`],
        bgColor: ["#FFF7A5", "#D4EAED"],
        // Used when there is no separate PM treatment product
        stepTitleCombo: ["Étape 4 • Soin Matin / Soir"],
        titleCombo: [`${sunIcon} AM / PM ${halfMoon}`],
        bgColorCombo: ["#D5E7D2"]
    },
    section_treatment_senstive: {
        stepTitle: ["Étape 4 • Soin du soir"],
        title: [`PM ${halfMoon}`],
        bgColor: ["#D4EAED"],
    },
    section_am_eyecare: {
        stepTitle: ["Étape 4.5 • Contour des yeux"],
        title: [`${sunIcon} AM`],
        bgColor: ["#FFF7A5"]
    },
    section_pm_eyecare: {
        stepTitle: ["Étape 4.5 • Contour des yeux"],
        title: [`${sunIcon} PM`],
        bgColor: ["#D4EAED"]
    },
    section_am_nourish: {
        stepTitle: ["Étape 5 • Crème de jour"],
        title: [`${sunIcon} AM`],
        bgColor: ["#FFF7A5"],
        // Used when there is no separate PM nourish product
        stepTitleCombo: ["Étape 5 • Crème Jour/Nuit"],
        titleCombo: [`${sunIcon} AM / PM ${halfMoon}`],
        bgColorCombo: ["#D5E7D2"]
    },
    section_pm_nourish: {
        stepTitle: ["Étape 5 • Crème de nuit"],
        title: [`${sunIcon} PM`],
        bgColor: ["#D4EAED"]
    },
    section_protect: {
        stepTitle: ["Étape 6 • Protection solaire"],
        title: [`${sunIcon} AM`],
        bgColor: ["#FFF7A5"]
    },
    section_booster: {
        title: `${starIcon} BOOSTER · 2 à 3× par semaine`,
        bgColor: ["#F3BF9F"]
    },
}

window.onload = function () {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

/** Reads quiz response id from the page URL (?resp_id=...). */
function getClientResponseId() {
    let tangent_client_url = new URL(window.location.href);
    return tangent_client_url.searchParams.get("resp_id");
}

/** Fetches recommended products for the quiz response from Tangent API. */
function checkoutDataApiCall(tangent_response_id) {
    // Skip API call when page was opened without a response id
    if (tangent_response_id != null) {
        const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id=" + tangent_response_id + "&self_serve=true" + "&multiple_variants=true";
        fetch(checkout_url)
            .then(data => {
                return data.json();
            })
            .then(response => {
                checkoutDataProcess(response);
                return response;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

/** Maps API response into page state and renders products / text sections. */
function checkoutDataProcess(response) {
    tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText;

    // Fallback currency symbol if Liquid did not provide one
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
    tangent_tags = response.tags;
    sensitiveSkin = response.tags.includes("skin_type_sensitive");
    setElementDisplay("loading-section", "none");
    setElementDisplay("tangent-banner-container", "block");
    setElementDisplay("tangent_recommendation_parent_wrapper", "block");
    emailResultBlock.style.display = response?.email_available ? "none" : "block";

    tangent_product_sections = response.product_sections;
    tangent_text_sections = response.text_sections;

    // Render selfie / copy-only sections (no product cards)
    if (response.text_sections != undefined) {
        createTextSection(tangent_product_sections, tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        //setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        setProductsToView_oldSetup(tangent_recommended_products, tangent_product_sections);
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    handlePregnancyMessage();
    //handleAutoAddToBag();
    handleAutoAddToBag_oldSetup();
}

/** Shows or hides the pregnancy-safe notice based on quiz tags. */
function handlePregnancyMessage() {
    if (tangent_tags?.includes("pregnancy_yes")) {
        pregnancyMessageContainer.style.display = "block";
    } else {
        pregnancyMessageContainer.style.display = "none";
    }
}

/**
 * On first load, auto-selects every routine product (Add → Added)
 * and seeds auto_add_to_bag_products so checkout totals are ready.
 */
function handleAutoAddToBag() {
    const addToBagButtons = document.querySelectorAll(".tangent-product-card-added-btn");
    addToBagButtons.forEach(button => {
        // Only process buttons still in the "Add" state
        if (button.classList.contains("add-btn")) {
            const price = button.dataset.productPrice;
            const productId = button.dataset.productId;
            const variantId = button.dataset.variantId;
            const comparePrice = button.dataset.comparePrice;
            auto_add_to_bag_products.push({ price, productId, variantId, comparePrice });

            button.classList.remove("add-btn");
            button.classList.add("added-btn");
            button.innerHTML = `
                <span class="tangent-product-card-added-icon">${tickIcon}</span>
                Ajouté
            `;
        }
    });
    updateCheckoutTotal();
}

/**
 * Recalculates bag totals, applies creator discount tiers when 3+ products,
 * and syncs checkout sidebar + per-card price labels.
 */
function updateCheckoutTotal() {
    let currentPrice = 0;
    let originalPrice = 0;

    for (const product of auto_add_to_bag_products) {
        let productPriceElement = document.getElementById(`product_${product.productId}`);

        // Bundle discount kicks in from 3 products onward
        if (auto_add_to_bag_products.length >= 3) {
            // Index into creator price list: 0 = 3 items, 1 = 4 items, etc.
            const discountPriceIndex = auto_add_to_bag_products.length - 3;
            const creatorPriceList = getCreatorPriceList(product.productId);

            if (creatorPriceList.length > 0) {
                const discountedPrice = creatorPriceList[discountPriceIndex];
                product.price = discountedPrice;

                if (productPriceElement) {
                    productPriceElement.textContent = `${tangent_client_domain_currency}${discountedPrice}`;
                }

                currentPrice += Number(discountedPrice);
                originalPrice += Number(product.comparePrice);
            }
            else {
                // No metafield prices — keep list / compare prices as-is
                currentPrice += Number(product.price);
                originalPrice += Number(product.comparePrice);
            }
        } else {
            // Under 3 products: show full price (no bundle discount)
            if (productPriceElement) {
                productPriceElement.textContent = `${tangent_client_domain_currency}${product.price}`;
            }
            currentPrice += Number(product.price);
            originalPrice += Number(product.comparePrice);
        }
    }

    const savings = originalPrice - currentPrice;

    // Toggle savings badge only when there is a real discount
    if (savings > 0) {
        checkoutSavingBadge.style.display = "block";
        checkoutSavingBadge.textContent = `Vous économisez ${savings.toFixed(2)}${tangent_client_domain_currency}`;
    } else {
        checkoutSavingBadge.style.display = "none";
        checkoutSavingBadge.textContent = "";
    }

    // Hide struck-through original when it matches the final total
    if (currentPrice == originalPrice) {
        checkoutOriginalPrice.style.display = "none";
        checkoutOriginalPrice.textContent = "";
    } else {
        checkoutOriginalPrice.style.display = "block";
        checkoutOriginalPrice.textContent = `${tangent_client_domain_currency}${originalPrice.toFixed(2)}`;
    }

    checkoutFinalPrice.textContent = `${tangent_client_domain_currency}${currentPrice.toFixed(2)}`;
    checkoutButton.innerHTML = `Ajouter toute la routine au panier <span>${tangent_client_domain_currency}${currentPrice.toFixed(2)}</span>`;
    updateCount();
}

/**
 * Returns the creator/bundle price array from the first variant metafield.
 * Value is a JSON string like ["26.10","24.92",...].
 */
function getCreatorPriceList(productId) {
    const product = tangent_recommended_products.find(product => product.id === productId);

    if (product?.variants?.edges?.length) {
        const creatorPriceList = product.variants.edges[0].node.setCreatorPrice?.value || "[]";
        return JSON.parse(creatorPriceList);
    }

    return [];
}

/** Updates product-count labels in header, main section, and email block. */
function updateCount() {
    const addedProductsCount = auto_add_to_bag_products.length;
    const countText = `${addedProductsCount} PRODUIT${addedProductsCount !== 1 ? 'S' : ''}`;
    checkouHeaderCount.textContent = countText;
    mainProductCount.textContent = countText;
    checkoutEmailCount.textContent = countText;
}

/**
 * Walks sectionsList, matches recommended product IDs, and appends
 * routine cards or booster cards into the correct grid containers.
 */
function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};
    const routineProductsGrid = document.querySelector(".tangent-routine-reco-container");
    const boosterProductsGrid = document.querySelector(".tangent-booster-reco-container");

    for (let i = 0; i < sectionsList.length; i++) {
        const section = sectionsList[i];
        let product_ids = sections[section];

        // Treatment fallback for sensitive-skin recommendations
        // if (product_ids === undefined && section === "section_treatment") {
        //     product_ids = sections["section_treatment_senstive"];
        // }

        // Skip missing or empty sections (e.g. no PM eyecare)
        if (!Array.isArray(product_ids) || product_ids.length === 0) {
            continue;
        }

        for (let j = 0; j < product_ids.length; j++) {
            const id = product_ids[j];

            for (let p = 0; p < products.length; p++) {
                if (String(products[p].id) === id) {
                    const product = products[p];
                    const variant = getSelectedVariant(product, selected_variants[product.id]); 
                    let isAvailable = isProductAvailable(product, variant);

                    if (isAvailable) {
                        tangent_selected_product_map[product.id] = extractVariantId(variant.id);
                        const product_html = getProductHTML(product, j, variant, section, product_ids);
                        if (!product_html) {
                            continue;
                        }

                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = product_html;

                        // Boosters go into their own container; all others into routine grid
                        if (section == "section_booster") {
                            boosterProductsGrid.appendChild(tempDiv.firstElementChild);
                        } else {
                            routineProductsGrid.appendChild(tempDiv.firstElementChild);
                        }
                    }
                    else {
                        console.log("product not available", product.title);
                    }
                }
            }
        }
    }

    window.updateReviewCounts?.();
}

/** Picks the quiz-selected variant, or falls back to the first variant. */
function getSelectedVariant(product, variant_list) {
    const productVariants = product.variants.edges || [];

    if (productVariants.length === 0) {
        throw new Error("No variants available for the product.");
    }

    if (variant_list.length > 0) {
        const selectedVariantId = Number(variant_list[0]);
        return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
    }

    return productVariants[0].node;
}

/** Escapes values interpolated into generated HTML attributes. */
function escapeHTMLAttribute(value) {
    return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
}

/** Builds the comma-separated product key list used by the reviews API. */
function getReviewProductIdentifiers(product) {
    const skus = (product.variants?.edges || [])
        .map(({ node }) => node?.sku)
        .filter(Boolean);
    const reviewHandles = product.reviewHandle?.value
        || product.review_handle?.value
        || [];
    const extraHandles = Array.isArray(reviewHandles) ? reviewHandles : [reviewHandles];

    return [...skus, product.handle, ...extraHandles.filter(Boolean)].join(",");
}

/**
 * Builds the same review-summary hook used by product cards across the theme.
 * product-reviews-count.js observes this element and fills in its rating/count.
 */
function getProductReviewHTML(product) {
    const recommendationWrapper = document.querySelector("#tangent_recommendation_parent_wrapper");
    const apiLink = recommendationWrapper?.dataset.reviewsApiLink;
    const locale = recommendationWrapper?.dataset.reviewsLocale;
    const handle = product.handle;

    if (!apiLink || !locale || !handle) {
        return "";
    }

    const skus = (product.variants?.edges || [])
        .map(({ node }) => node?.sku)
        .filter(Boolean);
    const reviewIdentifiers = getReviewProductIdentifiers(product);

    return `
        <span
            class="p p--capture js-review-summary product-item__reviews"
            data-id="${escapeHTMLAttribute(product.id)}"
            data-product-sku="${escapeHTMLAttribute(skus[0] || "")}"
            data-product-title="${escapeHTMLAttribute(product.title)}"
            data-product-type="${escapeHTMLAttribute(product.productType || "")}"
            data-lang="${escapeHTMLAttribute(locale)}"
            data-product="${escapeHTMLAttribute(reviewIdentifiers)}"
            data-api-link="${escapeHTMLAttribute(apiLink)}"
            data-page="1"
        ></span>
    `;
}

/**
 * Builds card HTML for one product.
 * Booster section uses a horizontal layout; routine sections use step + AM/PM cards.
 */
function getProductHTML(product, productIndex, variant, section, section_product_ids) {
    const variantId = extractVariantId(variant.id);
    const variantImageUrl = getVariantImage(variant, product);
    const isAvailable = isProductAvailable(product, variant);
    const variantProductUrl = `${product.onlineStoreUrl}?variant=${variantId}`;
    const isTreatmentProductUnique = checkUniqueTreatmentProducts(tangent_product_sections["section_treatment"] || [], tangent_product_sections["section_treatment_senstive"]);

    // Booster cards: no STEP header / AM-PM row — horizontal layout instead
    if (section === "section_booster") {
        return `
            <div class="tangent-booster-card">
                <div class="tangent-booster-card-header">
                    <div class="tangent-booster-card-header-text">${sectionConfig[section].title}</div>
                </div>

                <div class="tangent-booster-card-body">
                    <div class="tangent-booster-card-image">
                        <a 
                            class="tangent-text-link"
                            target="_blank"
                            href="${variantProductUrl}"
                        >
                            <img src="${variantImageUrl}" alt="${product.title}">
                        </a>
                    </div>

                    <div class="tangent-booster-card-info">
                        <div class="tangent-booster-card-reviews">
                            ${getProductReviewHTML(product)}
                        </div>
                        <h3 class="tangent-booster-card-title">${product.title}</h3>
                        <p class="tangent-booster-card-subtitle">${product.productSubtitle?.value || ""}</p>
                        <div class="tangent-booster-card-tags">
                            ${getProductFeatures(product.routineFinderTags)}
                        </div>
                    </div>
                </div>

                <div class="tangent-booster-card-footer">
                    <div class="tangent-booster-card-price">
                        ${variant.compareAtPrice ? `<span class="tangent-booster-card-original-price">${tangent_client_domain_currency}${variant.compareAtPrice}</span>` : ""}
                        <span class="tangent-booster-card-current-price" id="product_${product.id}">${tangent_client_domain_currency}${variant.price}</span>
                    </div>
                    <button type="button" class="tangent-booster-card-add-btn add-btn" ${isAvailable ? "" : "disabled"}
                    data-product-price="${variant.price}" data-product-id="${product.id}" data-variant-id="${variantId}" data-compare-price="${variant?.compareAtPrice || variant.price}"
                    onclick="handleAddToBag(this)">
                        <span class="tangent-product-card-added-icon">${plusIcon}</span>
                        Ajouter
                    </button>
                </div>
            </div>
        `;
    }

    let stepTitle = sectionConfig[section].stepTitle[productIndex];
    let title = sectionConfig[section].title[productIndex];
    let bgColor = sectionConfig[section].bgColor[productIndex];
    const showSensitiveTreatment = sensitiveSkin && isTreatmentProductUnique;

    // Skip extra AM treatment cards when sensitive treatment will cover PM
    if (section === "section_treatment" && productIndex > 0 && showSensitiveTreatment) {
        return "";
    }

    // Only render sensitive treatment when it's needed and unique
    if (section === "section_treatment_senstive" && !showSensitiveTreatment) {
        return "";
    }

    // Combine day + night treatment label when PM is not a separate unique product
    if (
        section === "section_treatment" &&
        section_product_ids.length === 1 &&
        !showSensitiveTreatment
    ) {
        stepTitle = sectionConfig[section].stepTitleCombo[productIndex];
        title = sectionConfig[section].titleCombo[productIndex];
        bgColor = sectionConfig[section].bgColorCombo[productIndex];
    }

    // Combine day + night cream label when PM nourish is not recommended
    if (section == "section_am_nourish" && tangent_product_sections["section_pm_nourish"] == undefined) {
        stepTitle = sectionConfig[section].stepTitleCombo[productIndex];
        title = sectionConfig[section].titleCombo[productIndex];
        bgColor = sectionConfig[section].bgColorCombo[productIndex];
    }

    return `
        <div class="tangent-product-card">
            <div class="tangent-product-card-header">
                <div class="tangent-product-card-step">${stepTitle}</div>
            </div>

            <div class="tangent-product-card-time" style="background-color: ${bgColor};">
                <div class="tangent-product-card-time-label">${title}</div>
            </div>

            <div class="tangent-product-card-image">
                <a 
                    class="tangent-text-link"
                    target="_blank"
                    href="${variantProductUrl}"
                >
                    <img src="${variantImageUrl}" alt="${product.title}">
                </a>
            </div>

            <div class="tangent-product-card-reviews">
                ${getProductReviewHTML(product)}
            </div>

            <h3 class="tangent-product-card-title">${product.title}</h3>
            <p class="tangent-product-card-subtitle">${product.productSubtitle?.value || ""}</p>

            <div class="tangent-product-card-tags">
                ${getProductFeatures(product.routineFinderTags)}
            </div>

            <div class="tangent-product-card-footer">
                <div class="tangent-product-card-price">
                    ${variant.compareAtPrice ? `<span class="tangent-product-card-original-price">${tangent_client_domain_currency}${variant.compareAtPrice}</span>` : ""}
                    <span class="tangent-product-card-current-price" id="product_${product.id}">${tangent_client_domain_currency}${variant.price}</span>
                </div>
                <button type="button" class="tangent-product-card-added-btn add-btn" ${isAvailable ? "" : "disabled"}
                data-product-price="${variant.price}" data-product-id="${product.id}" data-variant-id="${variantId}" data-compare-price="${variant?.compareAtPrice || variant.price}"
                onclick="handleAddToBag(this)">
                    <span class="tangent-product-card-added-icon">${plusIcon}</span>
                    Ajouter
                </button>
            </div>
        </div>
`;
}

/**
 * Returns true if the sensitive treatment product is unique
 * (i.e. not already present in section_treatment).
 * sectionSensitive always contains a single product id.
 */
function checkUniqueTreatmentProducts(sectionTreatment, sectionSensitive) {
    if (!Array.isArray(sectionSensitive) || sectionSensitive.length === 0) {
        return true;
    }

    if (!Array.isArray(sectionTreatment) || sectionTreatment.length === 0) {
        return true;
    }

    const sensitiveProductId = String(sectionSensitive[0]);
    const isDuplicate = sectionTreatment.some((productId) => String(productId) === sensitiveProductId);

    return !isDuplicate;
}

/**
 * Toggles a single product in/out of the bag.
 * - Added state → remove from bag and reset button to Add
 * - Add state → push into bag and mark as Added
 */
function handleAddToBag(addBtn) {
    const productPrice = addBtn.dataset.productPrice;
    const productId = addBtn.dataset.productId;
    const variantId = addBtn.dataset.variantId;
    const comparePrice = addBtn.dataset.comparePrice;

    // Remove from bag
    if (addBtn.classList.contains("added-btn")) {
        let productPriceElement = document.getElementById(`product_${productId}`);
        productPriceElement.textContent = `${tangent_client_domain_currency}${productPrice}`;
        auto_add_to_bag_products = auto_add_to_bag_products.filter(
            product => String(product.variantId) !== String(variantId)
        );
        addBtn.classList.remove("added-btn");
        addBtn.classList.add("add-btn");
        addBtn.innerHTML = `
            <span class="tangent-product-card-added-icon">${plusIcon}</span>
            Ajouter
        `;
    }
    // Add to bag
    else if (addBtn.classList.contains("add-btn")) {
        auto_add_to_bag_products.push({ price: productPrice, productId: productId, variantId: variantId, comparePrice: comparePrice });
        addBtn.classList.remove("add-btn");
        addBtn.classList.add("added-btn");
        addBtn.innerHTML = `
            <span class="tangent-product-card-added-icon">${tickIcon}</span>
            Ajouté
        `;
    }

    updateCheckoutTotal();
}

/**
 * Builds Shopify cart/add.js payload for all bag products as one bundle
 * (shared _bundleID so the cart drawer groups them).
 */
function handleAddAllToCart(addAllBtn) {
    if (!auto_add_to_bag_products.length) {
        return;
    }

    const button = addAllBtn || checkoutButton;
    if (!button || button.dataset.loading === "true") {
        return;
    }

    const originalButtonContent = button.innerHTML;
    button.dataset.loading = "true";
    button.disabled = true;
    button.innerHTML = `<span class="tangent-checkout-button-loader" aria-hidden="true"></span>`;

    const bundleId = uuidv4();
    const payload = {
        items: auto_add_to_bag_products.map(product => {
            // Shopify line-item property prices are stored in cents
            const originalPrice = Number(product.comparePrice || product.price) * 100;
            const pricePerItem = Number(product.price) * 100;

            return {
                id: product.variantId,
                quantity: 1,
                properties: {
                    _bundleID: bundleId,
                    _bundleImage: "//yepoda.com/cdn/shop/collections/YOUR_FAVOURITES.webp?v=1737125333&width=110",
                    Bundle: "Your set №1",
                    _bundleLink: "/collections/your-favorites",
                    _originalQuantity: 1,
                    _originalPrice: originalPrice,
                    _pricePerItem: pricePerItem
                }
            };
        })
    };

    addBundleToCart(payload, button, originalButtonContent);
}

/**
 * Posts the bundle payload to /cart/add.js, then refreshes / opens the cart drawer.
 * Matches the theme pattern used in skin-analizer / cart-drawer.js.
 */
function addBundleToCart(payload, button, originalButtonContent) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }).then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
            throw data;
        }

        if (button && originalButtonContent != null) {
            button.innerHTML = originalButtonContent;
            button.disabled = false;
            delete button.dataset.loading;
        }

        if (typeof window.updateDrawer === 'function') {
            await window.updateDrawer(true);
        }

        if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
        } else {
            document.body.classList.add('body--overflow-hidden');
            document.querySelector('.overlay')?.classList.add('overlay--active');
            document.querySelector('.cart-drawer')?.classList.add('cart-drawer--active');
        }
    }).catch((error) => {
        console.error('Error adding bundle to cart:', error);

        if (button && originalButtonContent != null) {
            button.innerHTML = originalButtonContent;
            button.disabled = false;
            delete button.dataset.loading;
        }
    });
}

/**
 * Builds feature/tag pills from product metafields.
 * Expects a comma-separated string, e.g. "Idratazione intensa,Lenisce e riequilibra la pelle".
 */
function getProductFeatures(feature) {
    if (!feature?.value) {
        return "";
    }

    return feature.value
        .split(",")
        .map((label) => label.trim())
        .filter(Boolean)
        .map((label) => `<span class="tangent-product-card-tag">${label}</span>`)
        .join("");
}

/** True when product is ACTIVE and the chosen variant is available for sale. */
function isProductAvailable(product, variant=undefined) {
    if (product.status !== "ACTIVE") {
        return false;
    }
    return variant != null ? variant.availableForSale : true;
}

/** Variant image → product image → default placeholder. */
const getVariantImage = (variant, product) => {
    if (variant.image?.url) {
        return variant.image.url;
    }
    else {
        if (product.images?.nodes[0]?.url) {
            return product.images.nodes[0].url
        }
        else {
            return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }
}

/** Strips Shopify GID prefix down to the numeric variant id. */
function extractVariantId(variantId) {
    return variantId.replace("gid://shopify/ProductVariant/", "");
}

/** Creates a wrapper div for a text/product section. */
function createSectionContainer(sectionName) {
    const sectionContainer = document.createElement("div");

    sectionContainer.id = `${sectionName}_container`;

    if (!["section_selfie", "section_booster"].includes(sectionName)) {
        sectionContainer.classList.add("tangent-section-container");
    }

    sectionContainer.classList.add(`${sectionName}_container`);

    return sectionContainer;
}

/** Injects section copy (from text_sections) above a product grid, when present. */
function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
    const sectionText = textSections[sectionName];

    if (sectionText) {
        const sectionDiv = document.createElement("div");
        sectionDiv.id = `${sectionName}_text_container`;
        sectionDiv.classList.add(
            "section_text_container",
            `${sectionName}_text_container`
        );
        sectionDiv.innerHTML = sectionText.join(" ");
        sectionContainer.appendChild(sectionDiv);
        return sectionDiv;
    }

    return '';
}

/**
 * Renders text-only sections that have no matching product_sections entry
 * (e.g. selfie analysis copy).
 */
function createTextSection(productSections, textSections) {
    for (const sectionName in textSections) {
        // Skip sections that already have product recommendations
        if (productSections[sectionName] !== undefined) {
            continue;
        }

        const sectionContainer = createSectionContainer(sectionName);

        createTextSectionBeforeProducts(
            textSections,
            sectionContainer,
            sectionName
        );

        // Selfie copy mounts under the selfie banner; everything else under sections wrapper
        if (sectionName === "section_selfie") {
            const selfieContainer = document.querySelector(
                "#section_selfie_container_parent"
            );

            if (selfieContainer) {
                selfieContainer.appendChild(sectionContainer);
            }
        } else {
            tangentProductSectionsWrapper.appendChild(sectionContainer);
        }
    }
}

/** Helper to show/hide an element by id (e.g. loading spinner). */
function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

/** Helper to validate email address. */
function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/** Save routine handle function */
async function handleSaveRoutine() {
    const email = document.getElementById("save-routine-email")?.value?.trim();
    const errorLabel = document.querySelector(".email-error");

    if (!email) {
        errorLabel.innerText = "Veuillez saisir votre adresse e-mail.";
        errorLabel.style.display = "block"
        return;
    }
    if (!isValidEmail(email)) {
        errorLabel.innerText = "S'il vous plaît, mettez une adresse email valide.";
        errorLabel.style.display = "block"
        return;
    }

    errorLabel.style.display = "none";

    const respId = getClientResponseId();

    const payload = {
        shop_id: "55199334465",
        form_id: "6a5a9f4b8ccc13a386d4bec5",
        resp_id: respId,
        responses: {
            form: {
                email
            }
        }
    };

    try {
        const response = await fetch(
            "https://service.tangent.ai/shopify/responses",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            }
        );

        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }

        const result = await response.json();
        emailResultBlock.style.display = "none";
    } catch (error) {
        console.error("Failed to send email", error);
    }
}


// Used for FR and IT stores
function setProductsToView_oldSetup(products, sections) {
    const routineProductsGrid = document.querySelector(".tangent-routine-reco-container");
    const boosterProductsGrid = document.querySelector(".tangent-booster-reco-container");

    for (let i = 0; i < sectionsList.length; i++) {
        const section = sectionsList[i];
        let product_ids = sections[section];

        // Skip missing or empty sections (e.g. no PM eyecare)
        if (!Array.isArray(product_ids) || product_ids.length === 0) {
            continue;
        }

        for (let j = 0; j < product_ids.length; j++) {
            const id = product_ids[j];

            for (let p = 0; p < products.length; p++) {
                if (String(products[p].id) === id) {
                    const product = products[p];
                    let isAvailable = isProductAvailable(product);

                    if (isAvailable) {
                        const product_html = getProductHTML_oldSetup(product, j, section, product_ids);
                        if (!product_html) {
                            continue;
                        }

                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = product_html;

                        // Boosters go into their own container; all others into routine grid
                        if (section == "section_booster") {
                            boosterProductsGrid.appendChild(tempDiv.firstElementChild);
                        } else {
                            routineProductsGrid.appendChild(tempDiv.firstElementChild);
                        }
                    }
                    else {
                        console.log("product not available", product.title);
                    }
                }
            }
        }
    }

    window.updateReviewCounts?.();
}

/**
 * Builds card HTML for one product.
 * Booster section uses a horizontal layout; routine sections use step + AM/PM cards.
 */
function getProductHTML_oldSetup(product, productIndex, section, section_product_ids) {
    const variantImageUrl = getProductImage_oldSetup(product);
    const isAvailable = isProductAvailable(product);
    const isTreatmentProductUnique = checkUniqueTreatmentProducts(tangent_product_sections["section_treatment"] || [], tangent_product_sections["section_treatment_senstive"]);

    // Booster cards: no STEP header / AM-PM row — horizontal layout instead
    if (section === "section_booster") {
        return `
            <div class="tangent-booster-card">
                <div class="tangent-booster-card-header">
                    <div class="tangent-booster-card-header-text">${sectionConfig[section].title}</div>
                </div>

                <div class="tangent-booster-card-body">
                    <div class="tangent-booster-card-image">
                        <img src="${variantImageUrl}" alt="${product.title}">
                    </div>

                    <div class="tangent-booster-card-info">
                        <div class="tangent-booster-card-reviews">
                            ${getProductReviewHTML(product)}
                        </div>
                        <h3 class="tangent-booster-card-title">${product.title}</h3>
                        <p class="tangent-booster-card-subtitle">${product.productSubtitle?.value || ""}</p>
                        <div class="tangent-booster-card-tags">
                            ${getProductFeatures(product.routineFinderTags)}
                        </div>
                    </div>
                </div>

                <div class="tangent-booster-card-footer">
                    <div class="tangent-booster-card-price">
                        <span class="tangent-booster-card-original-price" id="product_${product.id}_compare_price"></span>
                        <span class="tangent-booster-card-current-price" id="product_${product.id}_current_price"></span>
                    </div>
                    <button type="button" class="tangent-booster-card-add-btn add-btn" ${isAvailable ? "" : "disabled"}
                    data-product-id="${product.id}"
                    onclick="handleAddToBag_oldSetup(this)">
                        <span class="tangent-product-card-added-icon">${plusIcon}</span>
                        Ajouter
                    </button>
                </div>
            </div>
        `;
    }

    let stepTitle = sectionConfig[section].stepTitle[productIndex];
    let title = sectionConfig[section].title[productIndex];
    let bgColor = sectionConfig[section].bgColor[productIndex];
    const showSensitiveTreatment = sensitiveSkin && isTreatmentProductUnique;

    // Skip extra AM treatment cards when sensitive treatment will cover PM
    if (section === "section_treatment" && productIndex > 0 && showSensitiveTreatment) {
        return "";
    }

    // Only render sensitive treatment when it's needed and unique
    if (section === "section_treatment_senstive" && !showSensitiveTreatment) {
        return "";
    }

    // Combine day + night treatment label when PM is not a separate unique product
    if (
        section === "section_treatment" &&
        section_product_ids.length === 1 &&
        !showSensitiveTreatment
    ) {
        stepTitle = sectionConfig[section].stepTitleCombo[productIndex];
        title = sectionConfig[section].titleCombo[productIndex];
        bgColor = sectionConfig[section].bgColorCombo[productIndex];
    }

    // Combine day + night cream label when PM nourish is not recommended
    if (section == "section_am_nourish" && tangent_product_sections["section_pm_nourish"] == undefined) {
        stepTitle = sectionConfig[section].stepTitleCombo[productIndex];
        title = sectionConfig[section].titleCombo[productIndex];
        bgColor = sectionConfig[section].bgColorCombo[productIndex];
    }

    return `
        <div class="tangent-product-card">
            <div class="tangent-product-card-header">
                <div class="tangent-product-card-step">${stepTitle}</div>
            </div>

            <div class="tangent-product-card-time" style="background-color: ${bgColor};">
                <div class="tangent-product-card-time-label">${title}</div>
            </div>

            <div class="tangent-product-card-image">
                <img src="${variantImageUrl}" alt="${product.title}">
            </div>

            <div class="tangent-product-card-reviews">
                ${getProductReviewHTML(product)}
            </div>

            <h3 class="tangent-product-card-title">${product.title}</h3>
            <p class="tangent-product-card-subtitle">${product.productSubtitle?.value || ""}</p>

            <div class="tangent-product-card-tags">
                ${getProductFeatures(product.routineFinderTags)}
            </div>

            <div class="tangent-product-card-footer">
                <div class="tangent-product-card-price">
                    <span class="tangent-product-card-original-price"  id="product_${product.id}_compare_price"></span>
                    <span class="tangent-product-card-current-price" id="product_${product.id}_current_price"></span>                    
                </div>
                <button type="button" class="tangent-product-card-added-btn add-btn" ${isAvailable ? "" : "disabled"}
                data-product-id="${product.id}" 
                onclick="handleAddToBag_oldSetup(this)">
                    <span class="tangent-product-card-added-icon">${plusIcon}</span>
                    Ajouter
                </button>
            </div>
        </div>
`;
}

/**
 * On first load, auto-selects every routine product (Add → Added)
 * and seeds auto_add_to_bag_products so checkout totals are ready.
 */
function handleAutoAddToBag_oldSetup() {
    const addToBagButtons = document.querySelectorAll(".tangent-product-card-added-btn");
    addToBagButtons.forEach(button => {
        // Only process buttons still in the "Add" state
        if (button.classList.contains("add-btn")) {
            const productId = button.dataset.productId;
            auto_add_to_bag_products.push({ productId: productId });

            button.classList.remove("add-btn");
            button.classList.add("added-btn");
            button.innerHTML = `
                <span class="tangent-product-card-added-icon">${tickIcon}</span>
                Ajouté
            `;
        }
    });
    updateCheckoutTotal_oldSetup();
}


/**
 * Toggles a single product in/out of the bag.
 * - Added state → remove from bag and reset button to Add
 * - Add state → push into bag and mark as Added
 */
function handleAddToBag_oldSetup(addBtn) {
    const productId = addBtn.dataset.productId;

    // Remove from bag
    if (addBtn.classList.contains("added-btn")) {
        let productPriceElement = document.getElementById(`product_${productId}`);
        auto_add_to_bag_products = auto_add_to_bag_products.filter(
            obj => String(obj.productId) !== String(productId)
        );
   
        addBtn.classList.remove("added-btn");
        addBtn.classList.add("add-btn");
        addBtn.innerHTML = `
            <span class="tangent-product-card-added-icon">${plusIcon}</span>
            Ajouter
        `;
    }
    // Add to bag
    else if (addBtn.classList.contains("add-btn")) {
        auto_add_to_bag_products.push({ productId: productId });
        addBtn.classList.remove("add-btn");
        addBtn.classList.add("added-btn");
        addBtn.innerHTML = `
            <span class="tangent-product-card-added-icon">${tickIcon}</span>
            Ajouté
        `;
    }

    updateCheckoutTotal_oldSetup();
}

/**
 * Recalculates bag totals, applies creator discount tiers when 3+ products,
 * and syncs checkout sidebar + per-card price labels.
 */
function updateCheckoutTotal_oldSetup() {
    let currentPrice = 0;
    let originalPrice = 0;

    for (const product of tangent_recommended_products) {
        let productPriceElement = document.getElementById(`product_${product.id}_current_price`);
        let productComparePriceElement = document.getElementById(`product_${product.id}_compare_price`);
        
        const variant = getSelectedVariant_oldSetup(product, auto_add_to_bag_products.length);

        if(productPriceElement) productPriceElement.textContent = `${tangent_client_domain_currency}${variant.price}`;
        if(productComparePriceElement) productComparePriceElement.textContent = (variant.compareAtPrice != variant.price) ? `${tangent_client_domain_currency}${variant.compareAtPrice}` : "";

        const isInBag = auto_add_to_bag_products.some(obj => String(obj.productId) === String(product.id));
        if (isInBag) {
            currentPrice += Number(variant.price);
            originalPrice += Number(variant.compareAtPrice);
        }
    }

    const savings = originalPrice - currentPrice;

    // Toggle savings badge only when there is a real discount
    if (savings > 0) {
        checkoutSavingBadge.style.display = "block";
        checkoutSavingBadge.textContent = `Vous économisez ${tangent_client_domain_currency}${savings.toFixed(2)}`;
    } else {
        checkoutSavingBadge.style.display = "none";
        checkoutSavingBadge.textContent = "";
    }

    // Hide struck-through original when it matches the final total
    if (currentPrice == originalPrice) {
        checkoutOriginalPrice.style.display = "none";
        checkoutOriginalPrice.textContent = "";
    } else {
        checkoutOriginalPrice.style.display = "block";
        checkoutOriginalPrice.textContent = `${tangent_client_domain_currency}${originalPrice.toFixed(2)}`;
    }

    checkoutFinalPrice.textContent = `${tangent_client_domain_currency}${currentPrice.toFixed(2)}`;
    checkoutButton.innerHTML = `AJOUTER AU PANIER <span>${tangent_client_domain_currency}${currentPrice.toFixed(2)}</span>`;
    updateCount();
}

/**
 * Builds Shopify cart/add.js payload for all bag products as one bundle
 * (shared _bundleID so the cart drawer groups them).
 */
function handleAddAllToCart_oldSetup(addAllBtn) {
    if (!auto_add_to_bag_products.length) {
        return;
    }

    const button = addAllBtn || checkoutButton;
    if (!button || button.dataset.loading === "true") {
        return;
    }

    const originalButtonContent = button.innerHTML;
    button.dataset.loading = "true";
    button.disabled = true;
    button.innerHTML = `<span class="tangent-checkout-button-loader" aria-hidden="true"></span>`;

    const bundleId = uuidv4();
    const payload = {
        items: auto_add_to_bag_products.map(obj => {

            const product = getProductById_oldSetup(obj.productId);
            const variant = getSelectedVariant_oldSetup(product, auto_add_to_bag_products.length);
            // Shopify line-item property prices are stored in cents
            const originalPrice = Number(variant.compareAtPrice) * 100;
            const pricePerItem = Number(variant.price) * 100;

            return {
                id: extractVariantId(variant.id),
                quantity: 1,
                properties: {
                    _bundleID: bundleId,
                    _bundleImage: "https://cdn.shopify.com/s/files/1/0551/9933/4465/files/Frame_1073714371_1.png?v=1784815111",
                    Bundle: "Your set №1",
                    _bundleLink: "/collections/your-favorites",
                    _originalQuantity: 1,
                    _originalPrice: originalPrice,
                    _pricePerItem: pricePerItem
                }
            };
        })
    };

    addBundleToCart(payload, button, originalButtonContent);
}

function getProductById_oldSetup(product_id) {
    return tangent_recommended_products.find(product => product.id === product_id);
}

function getSelectedVariant_oldSetup(product, totalAddedProducts) {
    const productVariants = product.variants.edges || [];

    if (productVariants.length === 0) {
        throw new Error("No variants available for the product.");
    }

    for (let i = 0; i < productVariants.length; i++) {
        const variant = productVariants[i].node;
        // Compare the variant.title in the format of `totalAddedProducts item(s) bundle`
        if (variant.title === `${totalAddedProducts} item${totalAddedProducts !== 1 ? 's' : ''} bundle`) {
            return variant;
        }
    }

    return productVariants[0].node;
}

/** Variant image → product image → default placeholder. */
const getProductImage_oldSetup = (product) => {
    if (product.images?.nodes[0]?.url) {
        return product.images.nodes[0].url
    }
    else {
        return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
}